import { render } from "./ExtendModal.vue?vue&type=template&id=cbe03f6e"
import script from "./ExtendModal.vue?vue&type=script&lang=js"
export * from "./ExtendModal.vue?vue&type=script&lang=js"

import "./ExtendModal.vue?vue&type=style&index=0&id=cbe03f6e&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__